import LOGO_EDISON from '../_img/logo_edison.png'
import LOGO_PREIN from '../_img/logo_prein.png'

// EDISON本番環境
export const URL_BASE='https://drone.cerd-edison.com/'
export const AWS_S3_BUCKET_NAME='drone-contents-oita'
export const COPYRIGHT_TEXT ='© 2019 CERD. Oita University. All Rights Reserved.'
export const LOGO_IMG = LOGO_EDISON
export const SERVICE_NAME = 'EDiSON'
export const DEFAULT_LAT = 33.238067
export const DEFAULT_LNG = 131.612506
export const MANUAL = 'drone_manual_ver5.pdf'
export const FLIGHT_MANUAL = 'drone_flight_manual_ver2.pdf'
export const FULL_PICTURE_VIDEO = 'full_picture.mp4'
export const FULL_PICTURE_VIDEO_THUMNAIL = 'full_picture.png'
export const NEIGHBORHOOD_IMPACT_STUDY_VIDEO = 'neighborhood_impact_study.mp4'
export const NEIGHBORHOOD_IMPACT_STUDY_VIDEO_THUMNAIL = 'neighborhood_impact_study.png'
export const HUMAN_IMPACT_STUDY_VIDEO = 'human_impact_study.mp4'
export const HUMAN_IMPACT_STUDY_VIDEO_THUMNAIL = 'human_impact_study.png'
export const SHOOTING_FOR_DETAIL_VIDEO = 'shooting_for_detail.mp4'
export const SHOOTING_FOR_DETAIL_VIDEO_THUMNAIL = 'shooting_for_detail.png'
export const SECONDARY_DISASTER_SHOOTING_VIDEO = 'secondary_disaster_shooting.mp4'
export const SECONDARY_DISASTER_SHOOTING_VIDEO_THUMNAIL = 'secondary_disaster_shooting.png'
export const SERVICE_TOP_URL = 'https://cerd-edison.com'
export const RISK_URL = 'https://risk-edison.com'
export const ARCHIVE_SITE_URL = 'https://archive.cerd-edison.com'
export const DASHBOARD_URL = 'https://dashboard.cerd-edison.com/'  